/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Music_NotesInputs */

const en_music_notes = /** @type {(inputs: Music_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( ♪ ) Music Notes...`)
};

const fr_music_notes = /** @type {(inputs: Music_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( ♪ ) Notes de musique...`)
};

const de_music_notes = /** @type {(inputs: Music_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( ♪ ) Musiknoten...`)
};

const it_music_notes = /** @type {(inputs: Music_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( ♪ ) Note musicali...`)
};

const ru_music_notes = /** @type {(inputs: Music_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( ♪ ) Музыкальные ноты...`)
};

const es_music_notes = /** @type {(inputs: Music_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( ♪ ) Notas musicales...`)
};

const zh_cn2_music_notes = /** @type {(inputs: Music_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`（♪）音符……`)
};

const ja_music_notes = /** @type {(inputs: Music_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( ♪ ) 音符...`)
};

const hi_music_notes = /** @type {(inputs: Music_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( ♪ ) संगीत नोट्स...`)
};

const pt_pt2_music_notes = /** @type {(inputs: Music_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( ♪ ) Notas musicais...`)
};

/**
* | output |
* | --- |
* | "( ♪ ) Music Notes..." |
*
* @param {Music_NotesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const music_notes = /** @type {((inputs?: Music_NotesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Music_NotesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_music_notes(inputs)
	if (locale === "de") return de_music_notes(inputs)
	if (locale === "it") return it_music_notes(inputs)
	if (locale === "ru") return ru_music_notes(inputs)
	if (locale === "es") return es_music_notes(inputs)
	if (locale === "zh-CN") return zh_cn2_music_notes(inputs)
	if (locale === "ja") return ja_music_notes(inputs)
	if (locale === "hi") return hi_music_notes(inputs)
	if (locale === "pt-PT") return pt_pt2_music_notes(inputs)
	return en_music_notes(inputs)
});